import { getTokens, selectUserOrgByApp } from '@rsos/sinatra';
import { checkStatus, parseJSON } from '@rsos/utils';
import { getMostRecentLocations } from '@rsos/utils/getMostRecentLoc';
import { getAPIHost } from '@rsos/utils/metaTags';
import serializeRequestError from '@rsos/utils/serializeRequestError';
import fetchRetry from '../fetchRetry';
import {
  CREATE_DEEP_LINK_START,
  CREATE_DEEP_LINK_SUCCESS,
  CREATE_DEEP_LINK_FAILED,
} from './actionTypes';

const createDeepLinkStart = () => ({ type: CREATE_DEEP_LINK_START });
const createDeepLinkSuccess = url => ({
  type: CREATE_DEEP_LINK_SUCCESS,
  url,
});
const createDeepLinkFailed = error => ({
  type: CREATE_DEEP_LINK_FAILED,
  error,
});

export const createDeepLink =
  (spatialObjectId, source) => (dispatch, store) => {
    dispatch(createDeepLinkStart());
    const { sinatra, emergencyCalls } = store();
    const callerID = emergencyCalls.selectedCallerID;
    const { mostRecentLocation } = getMostRecentLocations(
      emergencyCalls.callQueue[callerID],
    );

    const incidentLocation = callerID ? mostRecentLocation : null;
    const { token } = getTokens();
    const org = selectUserOrgByApp(sinatra, 'capstone') || {};
    return fetchRetry(`${getAPIHost()}/v1/deeplink/${source}/${org.name}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        spatial_object_id: spatialObjectId,
        ...(incidentLocation && {
          location: {
            latitude: incidentLocation?.latitude,
            longitude: incidentLocation?.longitude,
            uncertainty_radius: incidentLocation?.uncertainty_radius,
            location_time: incidentLocation?.location_time,
          },
          application: incidentLocation?.application,
        }),
      }),
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(res => {
        return dispatch(createDeepLinkSuccess(res.url));
      })
      .catch(async err => {
        const serializedError = await serializeRequestError(err);
        throw dispatch(createDeepLinkFailed(serializedError));
      });
  };

export const createAppLauncherDeeplink =
  (endpointSuffix, callerID) => (dispatch, store) => {
    dispatch(createDeepLinkStart());
    const { sinatra } = store();
    const { token } = getTokens();
    const org = selectUserOrgByApp(sinatra, 'capstone') || {};

    return fetchRetry(
      `${getAPIHost()}/v1/deeplink/${endpointSuffix}/${org.id}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          query: `tel://${callerID}`,
        }),
      },
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(res => {
        return dispatch(createDeepLinkSuccess(res.url));
      })
      .catch(err => {
        throw dispatch(createDeepLinkFailed(err));
      });
  };

export default createDeepLink;
